/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KpiBodyDto
 */
export interface KpiBodyDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof KpiBodyDto
     */
    users: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof KpiBodyDto
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof KpiBodyDto
     */
    endDate: string;
}

/**
 * Check if a given object implements the KpiBodyDto interface.
 */
export function instanceOfKpiBodyDto(value: object): value is KpiBodyDto {
    if (!('users' in value) || value['users'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    return true;
}

export function KpiBodyDtoFromJSON(json: any): KpiBodyDto {
    return KpiBodyDtoFromJSONTyped(json, false);
}

export function KpiBodyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KpiBodyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'users': json['users'],
        'startDate': json['startDate'],
        'endDate': json['endDate'],
    };
}

export function KpiBodyDtoToJSON(json: any): KpiBodyDto {
    return KpiBodyDtoToJSONTyped(json, false);
}

export function KpiBodyDtoToJSONTyped(value?: KpiBodyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': value['users'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
    };
}

